import {IFilters, IQuickFilter} from '@stencil/hotels-types/src/srp-types';
import {ICheckinCheckoutDate} from '@stencil/hotels-types/src/hotels-types';

import getCheapestRoomData from '@stencil/hotels-utils/src/get-cheapest-room-data';

export type EmiDataType = ReturnType<typeof getCheapestRoomData>['emiData'];
// import { ValuesType, Optional } from 'utility-types';
export enum FetchStatusType {
  NOT_STARTED = 'NOT_STARTED',
  PENDING = 'PENDING',
  RESOLVED = 'RESOLVED',
  REJECTED = 'REJECTED',
}

export enum HotelListPlaceHolderType {
  AdTech = 'adtech',
  GoStreakSRPUnfiltered = 'GoStreakSRPUnfiltered',
  NowOrNeverDeal = 'NowOrNeverDeal',
  QuickBookRecommendations = 'QuickBookRecommendations',
  MaldivesCityGuide = 'MaldivesCityGuide',
  CoupleFriendlySRP = 'CoupleFriendlySRP',
  SmartEngageBanner = 'SmartEngageBanner',
  SignUpBanner = 'SignUpBanner',
  SegmentSlider = 'SegmentSlider',
  GoStreakSRPFiltered = 'GoStreakSRPFiltered',
  FilterWidget = 'FilterWidget',
  TopFilterCard = 'INDIANNESS',
  SaleCampaign = 'SALE',
  PolarisCard = 'POLARIS',
}

export interface ISrpStoreState {
  srpConfig: ISrpConfig;
}

export interface selectedHotelItemData {
  showPrice?: number;
}

export interface ISrpOfferData {
  (key: string): {data: Array<ISrpOfferDataItem>; error: string};
}

export interface ISrpSeoData {
  faqs: Array<IFaqData>;
  article: {
    desc: string;
    title: string;
  };
  meta: Array<object>;
  cityInfo: object;
  seoLinks: Array<object>;
  pageTitle: string;
  pageHeading: string;
  breadCrumbData: Array<object>;
  filterLinks: Array<{
    link_data: Array<object>;
    title: string;
  }>;
  footerLinks: Array<{
    link_data: Array<object>;
    title: string;
  }>;
  templateName: string;
  numberOfHotelsinFirstLoad?: number;
  showHotelCardDesc?: boolean;
}

export interface ISrpOfferDataItem {
  ty?: string;
  pa?: number;
  pt?: string;
  st?: string;
}

interface IFaqData {
  q: string;
  a: string;
}

export interface ISrpConfig {
  filter?: IFilters;
  metaPartner?: string;

  s?: string; // sorting
  cur?: string; // currency
  im?: boolean;
  ibp?: string;

  hmd?: string;
  // next?: string;
  pc?: string;
  pcf?: number;
  la?: string;
  lo?: string;
  rank?: string;
  isGds?: boolean;
  overriderankvhids?: string;
  overriderankvhidName?: string;
  segmentSliderHctxIndex?: number;
  currentExpandedStickyFilter?: string;
}

export interface IRegionCity {
  id?: string;
  ind?: string;
  name?: string;
}

export interface ISrpQueryParams {
  partner: string;
  cityName?: string;
  cityId: string;
  hotelQuery?: string;
  entityId?: string;
  metaPartner?: string;
  hquery?: string;
}

export interface ISrpData {
  augur_exp?: string;
  city_meta_info?: ICityMetaInfo;
  data: Array<IHotelData>;
  next: string;
  hydra_seg: Array<string>;
  error?: boolean;
  backfill_data?: BackFillData;
  hermes_exp?: HermesExp;
  lastFetchedWindowInfo?: string;
}

export interface HermesExp {
  hero_image: number;
  showChildBed: number;
  new_user_comm: number;
  apeintl_gi: number;
  bpg: number;
  [key: string]: any;
  Couple_Friendly_Intent?: boolean;
}

export interface BackFillData {
  data: Array<IHotelData>;
  heading: string;
  sub_heading: string;
}

export interface IHotelData {
  adp: number;
  ami?: [number];
  bt?: string;
  fcp: string;
  hn: string;
  hr?: number;
  hti?: number;
  l: string;
  lib?: string;
  opr: number;
  spr: number;
  do?: number;
  pxper: number;
  rec?: number;
  rtn: string;
  si: Array<string>;
  goTribeRevampPersuasion: IGoTribeRevampPersuasion;
  hi: Array<ISRPHotelThumbnailImages>;
  oip?: Array<IPersuasionText>;
  bbp?: Array<IPersuasionText>;
  cp1?: Array<IPersuasionText>;
  cp2?: Array<IPersuasionText>;
  arp?: Array<IPersuasionText>;
  bpp?: Array<IPersuasionText>;
  tnc?: number;
  ofs?: string;
  cbm?: string;
  app?: Array<IPersuasionText>;
  bp?: Array<IPersuasionText>;
  tgi?: Array<number>;
  rac?: Array<number>;
  distl?: Array<string>;
  pph?: string;
  dspr?: number;
  npp?: Array<IPersuasionText>;
  af?: string[]; // list of applied filter codes
  // aci: [number];
  // cbm: string;
  // ch: string;
  // chc: string;
  // cot: string;
  // dtc: number;
  emi?: EmiDataType['emi'];
  emid?: EmiDataType['emiRates'];
  // gos_flag: number;
  gr?: number;
  grc?: number;
  gri?: number;
  // grti: number;
  // gseg: string;
  // gsv: string;
  hc: number;
  // hfe: number;
  // hmd: string;
  // ibp: string;
  // is_aa: number;
  // la: number;
  // lo: number;
  // nbi: [number];
  // ofs: string;
  // oi: [number];
  // pm: number;
  // pph: string;
  // pr: number;
  // ptl: []

  // sb: number;
  // sld: string;
  t?: string;
  // tax: number;
  // ti: number;
  ut?: string;
  rnpl?: number;
  // vi: number;
}

export interface ISRPHotelThumbnailImages {
  si: string; // for small images
  mi: string; // for medium images
}

export interface IGoTribeRevampPersuasion {
  info: {
    persuasionId: string;
    goTribeIconUrlV2: string;
    template: number;
    ctaHeading: string;
    ctaGoTribeIconUrlV2: string;
    popUpBgColourCode: Array<string>; // ["#ffece5", "#00ffffff"],
    maxCount: number;
    ctaText: string;
  };
  data: IGoTribeRevampPersuasionData[];
}

export interface IGoTribeRevampPersuasionData {
  pt: string;
  ccd: {
    tc: string;
    gs: string;
    ge: string;
  };
  pid: string;
  iu: string;
  tp: number;
}

export interface IPersuasionText {
  pt: string;
  ccd?: IPersuasionColor;
  htd?: {
    h?: string;
    ht?: Array<string>;
    ft?: string;
    hec?: IPersuasionColor;
    hoc?: IPersuasionColor;
    ic?: string;
  };
  fd?: IFilters;
  ic?: string;
  ui?: string;
}

export interface IPersuasionColor {
  tc?: string;
  bgc?: string;
}

// export interface IPtl {
//   ic: string;
//   img: [string];
//   t: string;
// }

export type IntentBannerData = {
  banner_data?: {
    image_url: string;
  };
  footer_data?: {
    text: string;
  };
  segment_details?: {
    slug: string;
  };
  rank?: Number | string;
};

export interface ICityMetaInfo {
  am: Array<string>;
  ata: Array<string>;
  aty: Array<string>;
  tabs: Array<string>;
  qf?: Array<IQuickFilter>;
  tl?: Array<{id: string; n: string}>;
  flt: Array<{n: string; fd: {(key: string): string}}>;
  hccm?: {[id: string]: string};
  gsm?: Array<string>;
  gsb?: any; // @Note Need to update with proper typescript
  hcl?: Array<string>;
  dln?: Array<string>;
  cardData?: CardDataItem[];
  // ac: [string];
  // altpx: string;
  // amc: IAmc;
  // banner_type: string;
  co: string;
  // coc: string;
  // collections: [ICollections];
  ct: string;
  dsl: [IDsl];
  // gos_msg: string;
  // grt: [string];
  // is_ipl: number;
  // la: number;
  // lgdin: number;
  lli: {
    [K: string]: string; // values are location voyager ids of static locations used in location and hotel search filter for checkboxes
  };
  ifilters: {
    filterType: string;
    flist: Array<{
      t: string;
      f: Object;
    }>;
    t: string;
  };
  cfilters: {
    flist: Array<{
      t: string;
      f: Object;
      ic: string;
      slg: string;
    }>;
    t: string;
  };
  // lo: number;
  // pax: string;
  // pid_max: number;
  // pot: [IPot];
  // pxgrn: number;
  // sb: number;
  // sb_msg: string;
  // scthr: number;
  // segments: [ISegments];
  // ti: number;
  // tot: [ITot];
  // tyhc: ITyhc;
  vcid?: string;
  // vcids: [string];
  // vcidsn: [string];
  utn?: string;
  intent_cards_list?: Array<IntentBannerData>;
  slug_based_filter?: {
    applied_filter: string;
    slug: string;
  };
  slotInfo?: Array;
}

interface CardActionFilter {
  filterGroup: string;
  filterValue: string;
  count: number;
  title: string;
  filterExist: boolean;
  quantityFilter: boolean;
  sequence: number;
  translationRequired: boolean;
  rangeFilter: boolean;
  lastApplied: boolean;
}

interface CardAction {
  filters: {
    filterList: {
      [key: string]: CardActionFilter[];
    };
  };
}

interface CardInfo {
  index: number;
  subType: string;
  id: string;
  titleText: string;
  subText: string;
  hasFilter: boolean;
  titleTextColor: string;
  cardAction: CardAction[];
  cardCondition: object;
  iconURL: string;
  hasAction: boolean;
  bgImageURL: string;
  templateId: string;
  hasTooltip: boolean;
  toggleAction: string;
  isClaimed: boolean;
}

interface CardDataItem {
  sequence: number;
  cardInfo: CardInfo;
}

export interface IUpdateHasGoSuggestSRPDataFlags {
  hasStoreGoSuggestData: boolean;
}

export interface IUpdateRecommendationPreviousBooking {
  previousBookingRecommendation;
}

export interface IUpdateSRPFSortFilterFlags {
  isCloseButtonClicked: boolean;
}

export interface IUpdateSRPNextWithNoEndFlag {
  isNextWithNoEndAndNoData: boolean;
}

export interface IFilters {
  range_ugc?: Array<number>;
  tags?: Array<string>;
  tag?: string;
  lid?: Array<string>;
  utag?: Array<IQuickFilterItem>;
  qf?: Array<IQuickFilter>;
  step_range?: Array<IStepRange>;
  star?: Array<number>;
  type?: Array<string>;
  chain?: Array<string>;
  amenities?: Array<string>;
  location_search?: Array<ILocation_Search>;
  fbfi?: number;
  pah?: number;
  isrnpl?: number;
  gt?: number;
  fcp?: number;
  ht?: string;
  dis?: Array<string>;
  hctx?: string;
}

export interface IStepRange {
  min: number;
  max: number;
}

export interface IUpdateSeoFlags {
  isSEO: boolean;
}

export interface IUpdateSeoUnifFlags {
  isSeoUnif: boolean;
}

export interface IDsl {
  n: string;
  ahc: number;
}

export type IHotelDataType =
  | 'SegmentSlider'
  | 'SignUpBanner'
  | 'SmartEngageBanner'
  | 'ExploreBySection';

export type ISrpHotelCardPersuasionTypes =
  | 'abovePricePersausion'
  | 'bannerPersuasion'
  | 'belowBannerPersuasion'
  | 'contentPersuasion1'
  | 'contentPersuasion2'
  | 'aboveRatePlanPersuasion'
  | 'customLocation'
  | 'belowPricePersuasion';

export interface UserCityPaxItem {
  cityId: string;
  checkin: ICheckinCheckoutDate;
  checkout: ICheckinCheckoutDate;
  pax: string;
  uuid: string;
}

export const UPDATE_SRP_CONFIG = 'UPDATE_SRP_CONFIG';
export const UPDATE_FILTER = 'UPDATE_FILTER';
export const UPDATE_PREVIOUS_BOOKING_RECOMMENDATION = 'UPDATE_PREVIOUS_BOOKING_RECOMMENDATION';
export const UPDATE_PREVIOUS_BOOKING_RECOMMENDATION_ERROR =
  'UPDATE_PREVIOUS_BOOKING_RECOMMENDATION_ERROR';
export const UPDATE_PREVIOUS_BOOKING_RECOMMENDATION_FETCH_STATUS =
  'UPDATE_PREVIOUS_BOOKING_RECOMMENDATION_FETCH_STATUS';

export interface IUpdate_Srp_Config {
  type: typeof UPDATE_SRP_CONFIG;
  actionData: ISrpConfig;
}

export interface IUpdate_Filter {
  type: typeof UPDATE_FILTER;
  actionData: IFilters;
}

export type SrpActionTypes = IUpdate_Filter | IUpdateHasGoSuggestSRPDataFlags;
